import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ARTICLES, JOURNAL_PATH } from "@/lib/journal-data";

// Homepage shows these three; every article is listed at /journal
const FEATURED = ["best-time-to-visit-bhutan", "bhutan-sustainable-development-fee", "druk-path-trek-packing-list"]
  .map((s) => ARTICLES.find((a) => a.slug === s))
  .filter(Boolean);

export default function Journal() {
  return (
    <section
      id="journal"
      data-testid="journal-section"
      className="relative py-24 md:py-40 bg-[#0A0B0A] text-[#F5F2EB]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid md:grid-cols-[220px_1fr_auto] gap-8 md:gap-16 mb-16 md:mb-24 items-end">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#F5F2EB]/60">
            <div className="flex items-center gap-3">
              <span className="w-6 h-px bg-[#D1492E]" />
              <span>Ch. 04 · Journal</span>
            </div>
          </div>

          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.94] tracking-tighter"
          >
            Field notes from <em className="italic text-[#D1492E]">Paro.</em>
          </motion.h2>

          <div className="text-sm text-[#F5F2EB]/60 max-w-xs">
            Slow-brewed travel writing from our curators — for the ones who
            plan first, book second.
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {FEATURED.map((post, i) => (
            <motion.article
              key={post.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.1,
                ease: [0.76, 0, 0.24, 1],
              }}
              className="group"
              data-testid={`journal-post-${i}`}
            >
              <Link to={`${JOURNAL_PATH}/${post.slug}`} className="block">
              <div className="relative overflow-hidden aspect-[4/5] bg-[#1a1b1a]">
                <motion.img
                  src={post.img}
                  alt={post.imgAlt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover duotone"
                  whileHover={{ scale: 1.06 }}
                  transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
                />
                <div className="absolute top-4 left-4 right-4 flex items-center justify-between text-[10px] uppercase tracking-[0.28em] text-white">
                  <span className="bg-[#D1492E] px-2.5 py-1">{post.tag}</span>
                  <span>{post.read}</span>
                </div>
              </div>
              <h3 className="mt-6 font-serif text-2xl md:text-3xl leading-tight font-light group-hover:text-[#D1492E] transition-colors duration-500">
                {post.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-[#F5F2EB]/65 font-light leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-5 inline-flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-[#F5F2EB]/80 group-hover:text-[#D1492E] transition-colors">
                <span className="w-6 h-px bg-current" />
                Read the story
              </div>
              </Link>
            </motion.article>
          ))}
        </div>

        <div className="mt-16 md:mt-20">
          <Link
            to={JOURNAL_PATH}
            data-testid="journal-all-link"
            className="btn-sharp inline-flex items-center gap-3 px-7 py-4 text-[11px] uppercase tracking-[0.22em] font-medium border border-[#F5F2EB]/80"
          >
            All Bhutan travel guides <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
